/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Deleting1Inputs */

const zh_organizationsettings_deleting1 = /** @type {(inputs: Organizationsettings_Deleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除中...`)
};

const en_organizationsettings_deleting1 = /** @type {(inputs: Organizationsettings_Deleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting...`)
};

const es_organizationsettings_deleting1 = /** @type {(inputs: Organizationsettings_Deleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminando...`)
};

/**
* | output |
* | --- |
* | "Deleting..." |
*
* @param {Organizationsettings_Deleting1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_deleting1 = /** @type {((inputs?: Organizationsettings_Deleting1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Deleting1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_deleting1(inputs)
	if (locale === "en") return en_organizationsettings_deleting1(inputs)
	return es_organizationsettings_deleting1(inputs)
});
export { organizationsettings_deleting1 as "organizationSettings_deleting" }